export enum EventType{
    HIT_EVENT,
    KIT_STATUS_EVENT,
    REVIVE_EVENT,
    MISSION_STATUS_EVENT
}